import { api_POST } from "./_api.js";

const emailLote_api = {
    Insert: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("EmailLote/", json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default emailLote_api;
